var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MapGoogleLoader',{attrs:{"map-config":_vm.mapConfig,"api-key":_vm.apiKey},scopedSlots:_vm._u([{key:"marker",fn:function({ google, map }){return [_c('MapGoogleMarker',{attrs:{"marker":_vm.marker,"google":google,"map":map}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }